import React from 'react';
import { useIntl } from 'react-intl';
import _isFunction from 'lodash/isFunction';
import mProduct from 'models/product';
// Custom
import { joinNonEmpty, getHocDisplayName } from 'utils/Tools';
import PageTitle from 'components/misc/PageTitle';

const withTitle = (pageTitleId, getTitleFromOwnProps) => (WrappedComponent) => {
  const WithTitle = (props) => {
    const intl = useIntl();
    // Begin of the title
    const titleStart = pageTitleId ? intl.formatMessage({ id: pageTitleId }) : null;
    // End of the title
    const titleEnd = _isFunction(getTitleFromOwnProps) ? getTitleFromOwnProps(props, intl) : null;

    let title = joinNonEmpty([titleStart, titleEnd], ' ');
    const mainTitle = useIntl().formatMessage({ id: mProduct.fromValue().labelId });
    title = joinNonEmpty([mainTitle, title], ' - ');
    return (
      <React.Fragment>
        <PageTitle title={title} />
        <WrappedComponent {...props} />
      </React.Fragment>
    );
  };

  WithTitle.displayName = getHocDisplayName('WithTitle', WrappedComponent);

  return WithTitle;
};

export default withTitle;



// WEBPACK FOOTER //
// ./hocs/WithTitle.js